import { DRAWER_ENTITIES } from '@/lib/constants/drawers'

export const DRAWER_STACK = {
  LIMIT_REACHED: 'Límite de paneles alcanzado. Cierra uno para abrir más',
  ENTITIES: {
    [DRAWER_ENTITIES.CONTROL]: 'Control',
    [DRAWER_ENTITIES.DOCUMENT]: 'Documento',
    [DRAWER_ENTITIES.EVIDENCE]: 'Evidencia',
    [DRAWER_ENTITIES.TASK]: 'Tarea',
    [DRAWER_ENTITIES.EMPLOYEE]: 'Empleado',
  },
}
